import React from 'react'
import { PALETTE } from '../../styles/constants'

function ToggleIcon({ width = 18, height = 18, color = PALETTE.gray80 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill="none">
      <rect width={width} height={height} rx="2" fill={color}/>
    </svg>
  )
}

export default ToggleIcon


